import CryptoJS, {format} from 'crypto-js'
import {get_suffix, randomString} from "@/utils/random";
import axios from "axios";
import { Message } from 'element-ui';
import store from '@/store';

/**
 * @description: 判断是否有公共权限点
 * @param {String} obj 所属公共权限 driver_detail: 司机详情
 * @param {String} key 权限点标识
 * @return {*}
 */
export function hasShareAuTh(obj, key) {
  return store.getters.shareMenuButtons[obj]?.includes(key)
}

/**
 * @description: 判断是否是合格的JSON字符串
 * @param {*} str 来源字符串
 * @return {*}
 */
export function isJSONStr(str) {
  try{
    if (JSON.parse(str) instanceof Object) {
      return true
    }
  } catch (error) {
    return false
  }
}

/**
 * Create kun on 2021/7/10
 * @param {object}columns excel-> cloumns is excel title
 * @param {arrary}list    excel-> list is excel data
 * @param {string}excelName excel-> excelName is excel name
 *
 */
export function excel(columns, list, excelName) {
  import("@/vendor/Export2Excel").then((excel) => {
    let tHeader = [],
      filterVal = [];
    columns?.forEach((item) => {
      tHeader.push(item.title);
      filterVal.push(item.key);
    });
    const data = list?.map((v) => filterVal.map((j) => v[j]));
    excel.export_json_to_excel({
      header: tHeader,
      data,
      filename: excelName,
      autoWidth: true,
      bookType: "xlsx",
    });
  });
  return true
}

/**
 * Create kun on 2021/8/10 decimal
 * @param {number|folat}val decimal is numerical value
 * @param {number} index decimal --> keep figures
 * @param {string} author wangweijie
 */

// 传值，和要保留的小数点后几位
export function decimal(val, index) {
  //将数字转换为字符串，防止控制台报错
  val = val?.toString()
  // 判断如果不是小数直接返回数据
  if (val?.indexOf('.') == -1) {
    return Number(val)
  }
  val = val?.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
  let regexp = new RegExp("\\.{" + index + ",}", 'g')
  // 拼接\d来控制保留小数个数
  let d_index = ""
  for (let i = 0; i < index; i++) {
    d_index = d_index + '\\d'
  }
  val = val?.replace(regexp, "."); //只保留第一个. 清除多余的
  let reg = eval(`/^(${'\\-'})*(${'\\d'}+)\.(${d_index}).*$/`)
  val = val
    ?.replace(".", "$#$")
    ?.replace(/\./g, "")
    ?.replace("$#$", ".");
  val = val?.replace(
    reg,
    "$1$2.$3"
  );
  return val
}

/**
 * Create kun on 2021/10/18 stringToNumber
 * @param {object-> json|Array} val A string is converted to a number
 * @param {string} author wangweijie
 * */
// 遍历提交数据中字符串类型转换为数组
export function stringToNumber(val) {
  if (typeof val == 'object') {
    if (Array.isArray(val) === true) {
      for (let i = 0; i < val?.length; i++) {
        if (typeof val[i] == 'string') {
          if (val[i] == Number(val[i])) {
            val[i] = Number(val[i])
          }
        } else if (typeof val[i] == 'object') {
          val[i] = stringToNumber(val[i])
        }
      }
    }
    if (Array.isArray(val) === false) {
      for (let key in val) {
        if (typeof val[key] == 'string') {
          if (val[key] == Number(val[key])) {
            val[key] = Number(val[key])
          }
        } else if (typeof val[key] == 'object') {
          val[key] = stringToNumber(val[key])
        }
      }
    }
  }
  return val
}

/**
 * Create kun on 2021/10/19 numberFewMultiple
 * @param {object-> json|Array} val A string is converted to a number
 * @param {string|number|folat} multiple a multiple
 * @param {string} author wangweijie
 * */
// 数据乘相应倍数
export function numberFewMultiple(val, multiple) {
  if (typeof val == 'object') {
    if (Array.isArray(val) === true) {
      for (let i = 0; i < val?.length; i++) {
        if (typeof val[i] == 'string' || typeof val[i] == 'number') {
          if (val[i] == Number(val[i])) {
            val[i] = Number(val[i] * multiple)
          }
        } else if (typeof val[i] == 'object') {
          val[i] = numberFewMultiple(val[i], multiple)
        }
      }
    }
    if (Array.isArray(val) === false) {
      for (let key in val) {
        if (typeof val[key] == 'string' || typeof val[key] == 'number') {
          if (val[key] == Number(val[key])) {
            val[key] = Number(val[key] * multiple)
          }
        } else if (typeof val[key] == 'object') {
          val[key] = numberFewMultiple(val[key], multiple)
        }
      }
    }
  }
  return val
}

/***
 * Create kun on 2021/12/09 copy
 * @param {object-> json} obj A Json object
 * @param {string} author wangweijie
 * Creating a copy prevents the copied object data from changing
 * */

export function copy(obj) {
  var copy = Object.create(Object.getPrototypeOf(obj));
  var propNames = Object.getOwnPropertyNames(obj);

  propNames.forEach(function (name) {
    var desc = Object.getOwnPropertyDescriptor(obj, name);
    Object.defineProperty(copy, name, desc);
  });

  return copy;
}

/***
 * Create kun on 2021/12/09 arrayAdd
 * @param {object-> array} array A array object
 * @param {string} author wangweijie
 * The incoming array must be an array of numbers
 * If you just compute the sum of arrays, you can also use "reduce"
 * For now, only one-dimensional arrays are supported
 * */
export function arrayAdd(array) {
  if (Array.isArray(array) === true) {
    function Counter() {
      this.sum = 0;
      this.count = 0;
    }

    Counter.prototype.add = function (array) {
      array.forEach(function (entry) {
        this.sum += entry;
        ++this.count;
      }, this);
    };
    var obj = new Counter()
    obj.add(array)
    return obj
  } else {
    console.log("Please enter an array")
    return
  }
}

/***
 * Create kun on 2021/12/09 copy
 * @param {object-> array} array A array object
 * @param {string} author wangweijie
 * For now, only one-dimensional arrays are supported
 * Count the number of occurrences of elements in an array, in JSON format
 * */
export function arrayStatistical(array) {
  if (Array.isArray(array)) {
    let json_count = array.reduce(function (allNames, name) {
      if (name in allNames) {
        allNames[name]++;
      } else {
        allNames[name] = 1;
      }
      return allNames;
    }, {})
    return json_count
  } else {
    console.log("Please enter an array")
    return
  }
}

/**
 * Create kun on 2021/12/10 copy
 * @param {number|string} array A array object
 * @param {string} author wangweijie
 * For now, only one-dimensional arrays are supported
 * For now, only strings and numbers are supported
 * */
export function arraySort(array) {
  if (Array.isArray(array)) {
    let string_sort = array.every(item => {
      if (typeof item !== "number" && typeof item === "string") {
        return true
      } else {
        return false
      }
    })
    let number_sort = array.every(item => {
      if (typeof item === "number" && typeof item !== "string") {
        return true
      } else {
        return false
      }
    })

    if (string_sort) {
      return array.sort((a, b) => {
        // Switching strings to uniform case for EASY ASCII encoding
        let a_string = a.toUpperCase()
        let b_string = b.toUpperCase()

        if (a_string > b_string) {
          return 1
        } else {
          return -1
        }
      })
    }
    if (number_sort) {
      return array.sort((a, b) => {
        return a - b
      })
    }
  } else {
    console.log("Please enter an array")
    return
  }
}

/**
 * Create kun on 2022/2/22 secondsConversionMinutes
 * @param {number}  seconds number
 * @param {string} author wangweijie
 * Converts seconds to minutes Returns a string of minutes plus seconds
 * */

export function secondsConversionMinutes(seconds) {
  let minutes = (seconds / 60).toFixed(0)
  let second = seconds - minutes * 60
  let minutes_string = minutes + "分"
  if (second > 0) {
    minutes_string = minutes + "分" + second + "秒"
  }
  return minutes_string
}

/**
 * Create kun on 2022/5/10 getQueryParams
 * @param {string}  params string
 * @param {string} author wangweijie
 * Gets the external URL parameter content
 * */
export function getQueryParams(params) {
  let reg = `(^|&)${params}=([^&]*)(&|$)`;
  console.log(reg);
  let r = window.location.search.substr(1).match(reg);
  console.log(r)
  if (r != null) return unescape(r[2]);
  return null;
}

/**
 * Create kun on 2022/8/25 encrypt
 * @param {string} key
 * @param {string} iv
 * @param {string} data
 * @param {string} author wangweijie
 * Content encryption
 * */
export function encrypt(key, iv, data) {
  if (typeof data === "object") {
    // 如果传入的data是json对象，先转义为json字符串
    try {
      data = JSON.stringify(data)
    } catch (error) {
      console.log("error:", error)
    }
  }
  // 统一将传入的字符串转成UTF8编码
  const dataHex = CryptoJS.enc.Utf8.parse(data) // 需要加密的数据
  const keyHex = CryptoJS.enc.Utf8.parse(key) // 秘钥
  const ivHex = CryptoJS.enc.Utf8.parse(iv) // 偏移量
  const encrypted = CryptoJS.DES.encrypt(dataHex, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.OFB, // 加密模式
    padding: CryptoJS.pad.AnsiX923
  })
  let encryptedVal = encrypted.ciphertext.toString()
  return encryptedVal //  返回加密后的值
}


// 解密数据
export function decrypt(key, iv, encryptedVal) {
  if (!encryptedVal) return '';
  let encryptedHexStr = CryptoJS.enc.Hex.parse(encryptedVal);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const keyHex = CryptoJS.enc.Utf8.parse(key) // 秘钥
  const ivHex = CryptoJS.enc.Utf8.parse(iv) // 偏移量
  let decrypt = CryptoJS.DES.decrypt(srcs, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.OFB,
    padding: CryptoJS.pad.AnsiX923
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

/**
 * Create kun on 2022/10/11 isTimeFormat
 * @param {string}  params string
 * @param {string} author wangweijie
 * @returns {Boolean}
 *
 * */
export function isTimeFormat(params) {
  var reg = /^[0-9,/:-\s]+$/;
  if ((!isNaN(Date.parse(new Date(params?.replace(/-/g, '/')))) && isNaN(params) && reg.test(params)) || (params?.indexOf('T') != -1 && !isNaN(new Date(params)))) {
    return true
  }
  return false
}

export function copyText(val) {
  var oInput = document.createElement("input");
  oInput.value = val;
  document.body?.appendChild(oInput);
  oInput.select(); // 选择对象
  document.execCommand("Copy"); // 执行浏览器复制命令
  oInput.className = "oInput";
  oInput.style.display = "none";
  Message({
    showClose: true,
    type: "success",
    message: "复制成功",
  })
}
/**
 * @description: 判断对象中是否存在某个属性为空值
 * @param {Object} obj 判断目标对象
 * @return {*}
 */
export function hasEmptyPropertyValue(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && (obj[key] === null || obj[key] === undefined || obj[key] === '')) {
      return true;
    }
  }
  return false;
}
